<template>
  <div>
    <div class="card mb-3">
      <div class="card-header">登録情報</div>
      <div class="card-body">
        <div class="mb-3">
          <!--suppress HtmlUnknownTarget -->
          <img v-if="member['image_filename']" :src="'./profile/image?' + member['image_filename']" style="width: calc(33vmin); height: calc(33vmin); object-fit: cover;" alt="">
          <div v-else class="border bg-light" style="width: calc(33vmin); height: calc(33vmin);"></div>
        </div>

        <dl class="row">
          <dt class="col-md-2">会員ID</dt>
          <dd class="col-md-10">{{ member["customer_id"] }}</dd>
          <dt class="col-md-2">プラン</dt>
          <dd class="col-md-10">{{ member["plan"]["name"] }}</dd>
          <dt class="col-md-2">ログインID</dt>
          <dd class="col-md-10">{{ member["name"] }}</dd>
          <dt class="col-md-2">メールアドレス</dt>
          <dd class="col-md-10">{{ member["email"] }}</dd>
        </dl>

        <div>
          <router-link to="/member/profile/edit" dusk="profile_edit" type="submit" name="submit" class="btn btn-success my-3">
            登録情報を変更する
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      id: this.$route.params.id,
      member: {
        plan: {}
      }
    }
  },
  async created() {
    this.$store.commit("loading/setLoading", true);

    // 戻りリンク先を設定
    this.$store.commit("backButton/setTo", "/member");

    await axios.get('/member/api/profile')
        .then(response => this.member = response.data.member)
        .catch(error => this.$store.state.error.code = error.response.status);

    this.$store.commit("loading/setLoading", false);
  }
}
</script>
